export function getEnvConfig () {
  const { origin, pathname, hostname } = window.location
  const pathParts = pathname.split('/').filter(Boolean)
  const basePath = pathParts.length > 0 ? `/${pathParts[0]}` : ''
  const fullBaseUrl = `${origin}${basePath}`

  let apiBaseUrl = ''
  if (hostname.includes('localhost')) {
    apiBaseUrl = 'https://api.dev.example.com'
  } else if (hostname.includes('staging.example.com')) {
    apiBaseUrl = 'https://api.staging.example.com'
  } else {
    apiBaseUrl = 'https://api.example.com'
  }

  return {
    origin,
    basePath,
    fullBaseUrl,
    apiBaseUrl
  }
}
